import React from 'react';
import styled from 'styled-components';
import { useBreakpoint, Box, BoxProps } from '@landr/maestro';

// Note: Maestro doesn't export Breakpoint
type Breakpoint = 'xs' | 'sm' | 'ms' | 'md' | 'lg' | 'xl' | 'xxl';

type HiddenRule = '>' | '<=';

interface HiddenProps extends BoxProps {
    at: Breakpoint;
    operator?: HiddenRule;
    hideWithStyle?: boolean;
}

const HiddenByCss = styled(Box)<{ isHidden: boolean }>`
    ${({ isHidden }): string => (isHidden ? `display: none;` : ``)}
`;

/**
 * Hidden hide his children on demand
 * By default we hide using styled component - it's the preferred method to minimized DOM manipulation
 * But when hideWidthStyle is false, we remove the children from the DOM by returning null
 */
export const Hidden: React.FC<HiddenProps> = ({
    at,
    as = Box,
    operator = '<=',
    hideWithStyle = true,
    children,
    color,
    ...props
}) => {
    let isHidden = false;
    const AsComponent = as;
    const isBreakpoint = useBreakpoint(at);

    if (operator === '<=') {
        isHidden = isBreakpoint;
    } else {
        isHidden = !isBreakpoint;
    }

    if (!hideWithStyle && isHidden) {
        return null;
    }

    if (!hideWithStyle && !isHidden) {
        return <AsComponent {...props}>{children}</AsComponent>;
    }

    return (
        <HiddenByCss forwardedAs={as} isHidden={isHidden} {...props}>
            {children}
        </HiddenByCss>
    );
};
